import { Link } from 'react-router-dom';
import { getHotArticles, getCategoryName, formatCount, formatDate } from '@/lib/content';
import ArticleListItem from '@/components/base/ArticleListItem';
import type { Article } from '@/types/content';

export default function HotPicks() {
  const hot = getHotArticles(5);
  const featured = hot[0];
  const rest = hot.slice(1);

  if (!featured) return null;

  return (
    <section id="hot" className="w-full scroll-mt-24 bg-background-50 px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="flex items-center gap-1 text-sm font-bold text-primary-600">
            <i className="ri-fire-line" aria-hidden="true"></i>
            今日热瓜
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            全网围观最多的离谱现场
          </h2>
        </div>
        <p className="text-sm text-foreground-600">按阅读量实时排序，每小时刷新一次</p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-2 lg:flex-row">
          <Link to={`/article/${featured.id}`} className="block h-56 lg:h-auto lg:w-1/2">
            <img
              src={featured.cover}
              alt={`${featured.title} 相关插画`}
              title={`${featured.title} - 猎奇吃瓜`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
          </Link>
          <div className="flex flex-1 flex-col justify-center p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-bold text-primary-700">
                TOP 1
              </span>
              <Link
                to={`/category/${featured.category}`}
                className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800"
              >
                {getCategoryName(featured.category)}
              </Link>
            </div>
            <h3 className="mt-3 font-heading text-xl leading-snug text-foreground-950 md:text-2xl">
              <Link to={`/article/${featured.id}`} className="transition-colors hover:text-primary-700">
                {featured.title}
              </Link>
            </h3>
            <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
              {featured.excerpt}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-3-line" aria-hidden="true"></i>
                {featured.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line" aria-hidden="true"></i>
                {formatDate(featured.date)}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {formatCount(featured.views)}
              </span>
            </div>
            <Link
              to={`/article/${featured.id}`}
              className="mt-5 flex w-fit items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              围观现场
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </article>

        <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
          <div className="mb-1 flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
              <i className="ri-bar-chart-2-line text-accent-600" aria-hidden="true"></i>
              热度排行榜
            </h3>
          </div>
          <div>
            {rest.map((item: Article, idx: number) => (
              <ArticleListItem key={item.id} article={item} index={idx} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}